import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"

export const useUrlParams = () => {
    const [urlParams, setUrlParams] = useSearchParams();
    const [params, setParams] = useState({});

    // Parse URL params into state
    useEffect(() => {
        const paramsObject = {};
        for (const [key, value] of urlParams.entries()) {
            // Always store as arrays
            paramsObject[key] = value.split(',');
        }
        setParams(paramsObject);
    }, [urlParams]);

    // Convert params object to URL format
    const paramsToUrl = (params) => {
        const urlObject = {};
        Object.entries(params).forEach(([key, value]) => {
            // Convert arrays to comma-separated strings
            if (Array.isArray(value)) {
                urlObject[key] = value.join(',');
            } else if (typeof value === 'string') {
                urlObject[key] = value;
            }
        });
        return urlObject;
    };

    const setParam = useCallback((param, value) => {
        if (value && (Array.isArray(value) ? value.length > 0 : value.trim() !== '')) {
            // Ensure value is an array
            const valueArray = Array.isArray(value) ? value : [value];
            
            // Update params state
            const newParams = { 
                ...params, 
                [param]: valueArray 
            };
            
            // Convert to URL format and update
            setUrlParams(paramsToUrl(newParams));
        } else {
            // Remove param if value is empty
            const { [param]: removed, ...newParams } = params;
            setUrlParams(paramsToUrl(newParams));
        }
    }, [setUrlParams, params]);

    const clearParam = useCallback(() => {
        setUrlParams({});
        setParams({});
    }, [setUrlParams]);

    return {
        params,
        search: `?${urlParams.toString()}`,
        setParam,
        clearParam
    }
}